"use client";

import { type HTMLAttributes, type PropsWithChildren, type Ref } from "react";

import cn from "../../utils/cn.util";
import { useCardContext } from "./context";
import { bodyStyles } from "./styles";

export type CardBodyProps = PropsWithChildren<{
  className?: string;
  style?: React.CSSProperties;
  ref?: Ref<HTMLDivElement>;
}> &
  HTMLAttributes<HTMLDivElement>;

export const Body = ({ ref, children, className, style, ...props }: CardBodyProps) => {
  const { variant } = useCardContext();

  return (
    <div className={cn(bodyStyles({ variant }), className)} style={style} ref={ref} {...props}>
      {children}
    </div>
  );
};

Body.displayName = "CardBody";
